export const breakpoints = {
  base: '0px',
  sm: '640px',
  md: '860px',
  lg: '1024px',
  xl: '1280px',
};
